import ProfitLossHTMLPreviewBaseSection from './ProfitLossHTMLPreviewBaseSection'

export default function ProfitLossHTMLPreviewHeaderSection() {}

ProfitLossHTMLPreviewHeaderSection.prototype = new ProfitLossHTMLPreviewBaseSection();

ProfitLossHTMLPreviewHeaderSection.prototype.init = function ( columnsStrategy )
{
    ProfitLossHTMLPreviewBaseSection.prototype.init.call( this, columnsStrategy );
    return this;
};

ProfitLossHTMLPreviewHeaderSection.prototype.addRows = function ( tBody )
{
    var row1 = this.createRow("headerRow firstHeaderRow");
    this.addCell(
            row1,
            this.message("report.cost_items"),
            "costItems",
            1, 2
    );
    this.columnsStrategy.addFirstHeaderRowCells(row1);

    var row2 = this.createRow("headerRow secondHeaderRow");
    this.columnsStrategy.addSecondHeaderRowCells(row2);

    this.addRow(tBody, row1);
    this.addRow(tBody, row2);
};


// WEBPACK FOOTER //
// ./web/js/reports/preview/html/profitloss/ProfitLossHTMLPreviewHeaderSection.js